import type {BaseRecord, CrudFilter, DataProvider, LogicalFilter} from "@refinedev/core";
import {ADMIN_RESOURCE_HANDLERS} from "./resourceHandlers";

function handler(resource: string) {
  const h = ADMIN_RESOURCE_HANDLERS[resource];
  if(!h) throw new Error(`Resursa admin necunoscuta: ${resource}`);
  return h;
}

function filterValue(filters: CrudFilter[] | undefined, field: string): string | undefined {
  const match = filters?.find((f): f is LogicalFilter => "field" in f && f.field === field);
  if(!match || match.value == null || match.value === "") return undefined;
  return String(match.value);
}

function filterNumber(filters: CrudFilter[] | undefined, field: string): number | undefined {
  const raw = filterValue(filters, field);
  if(raw == null) return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

export const adminDataProvider = {
  getApiUrl: () => "",

  getList: async ({resource, pagination, filters}) => {
    const h = handler(String(resource));
    const page = pagination?.currentPage ?? 1;
    const pageSize = pagination?.pageSize ?? 20;
    const result = await h.list({
      page,
      pageSize,
      search: filterValue(filters, "search"),
      status: filterNumber(filters, "status"),
      dateFrom: filterValue(filters, "dateFrom"),
      dateTo: filterValue(filters, "dateTo")
    });
    return {data: result.items as BaseRecord[], total: result.total} as Awaited<ReturnType<DataProvider["getList"]>>;
  },

  getOne: async ({resource, id}) => {
    const h = handler(String(resource));
    if(!h.getOne) throw new Error(`getOne nu e suportat pentru ${resource}`);
    const data = await h.getOne(Number(id));
    return {data: data as BaseRecord} as Awaited<ReturnType<DataProvider["getOne"]>>;
  },

  create: async ({resource, variables}) => {
    const h = handler(String(resource));
    if(!h.create) throw new Error(`create nu e suportat pentru ${resource}`);
    const data = await h.create(variables as Record<string, unknown>);
    return {data: data as BaseRecord} as Awaited<ReturnType<DataProvider["create"]>>;
  },

  update: async ({resource, id, variables}) => {
    const h = handler(String(resource));
    if(!h.update) throw new Error(`update nu e suportat pentru ${resource}`);
    const data = await h.update(Number(id), variables as Record<string, unknown>);
    return {data: data as BaseRecord} as Awaited<ReturnType<DataProvider["update"]>>;
  },

  deleteOne: async ({resource, id}) => {
    const h = handler(String(resource));
    if(!h.deleteOne) throw new Error(`delete nu e suportat pentru ${resource}`);
    await h.deleteOne(Number(id));
    return {data: {id} as BaseRecord} as Awaited<ReturnType<DataProvider["deleteOne"]>>;
  }
} as DataProvider;
